import './App.css';
import './styles/form.css'
import Form from './components/container';

function App() {
  return (
    <div className="App">
      <Form></Form>
    </div>
  );
}

export default App;
